<template>
  <div class="unknown-wrapper">
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <i class="fas fa-eye-slash big-eyes mb-5"></i>
          <h3>Preview unavailable for this file</h3>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Unknown',
  mounted() {
    this.$emit('loaded', true)
  }
}
</script>

<style scoped>
.unknown-wrapper {
  min-height: 500px;
  height: 500px;
}
.big-eyes {
  font-size: 32px;
}
</style>